var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (imageUrls, undefined) {
// iterate imageUrls
;(function(){
  var $$obj = imageUrls;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var url = $$obj[$index];

buf.push("<img" + (jade.attr("src", url, true, true)) + ">");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var url = $$obj[$index];

buf.push("<img" + (jade.attr("src", url, true, true)) + ">");
    }

  }
}).call(this);
}.call(this,"imageUrls" in locals_for_with?locals_for_with.imageUrls:typeof imageUrls!=="undefined"?imageUrls:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;